<template>
  <!-- back to top -->
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="backtotop-btn-style primary"
             fab
             small
             icon
             v-bind="attrs"
             v-on="on"
             @click="backtop"
             v-show="isShowTop">
        <v-icon color="white">mdi-arrow-up-bold</v-icon>
      </v-btn>
    </template>
    <span>Back To Top</span>
  </v-tooltip>
</template>

<script>

export default {
  name: 'BackToTop',
  data() {
    return {
      isShowTop: false,
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {// 滚动事件
      let html = document.documentElement;
      if (html.scrollTop >= 100) {//当滚动高度大于等于100返回顶部出现
        this.isShowTop = true
      } else {
        this.isShowTop = false
      }
    })
  },
  methods: {
    backtop() {
      //  document.documentElement.scrollTop=0
      let html = document.documentElement
      var timer = setInterval(() => {
        if (html.scrollTop <= 0) {
          clearInterval(timer)
        }
        html.scrollTop = html.scrollTop - 20
      }, 0);
    },
  },

}
</script>
<style scoped lang="sass">
.backtotop-btn-style
  position: fixed
  right: 1%
  top: 85%
  transform: translateY(-50%)
  z-index: 99
</style>